import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';

import {Params, ActivatedRoute} from "@angular/router";
import {DataService} from "../services/data.service";
import {ApiService} from "../services/api.service";
import {Setting} from "../type/setting";

@Component({
    selector: 'app-setting-edit',
    templateUrl: './setting-edit.component.html',
    styleUrls: ['./setting-edit.component.css']
})
export class SettingEditComponent implements OnInit {

    node = 'setting';
    setting: Setting = Setting;

    constructor(private dataService: DataService,
                private apiService: ApiService,
                private route: ActivatedRoute,
                private location: Location) {
    }

    ngOnInit(): void {
        this.dataService.refresh();
        this.route.params
            .subscribe(
                (params: Params) => {
                    this.apiService.getUsingId(this.node, +params['id'])
                        .subscribe((response) => {
                            this.dataService.updateActiveRequestNo(-1);
                            this.setting = response.json().data[0];
                        });
                }
            );
    }

    onFormSubmit() {
        this.apiService.update(this.node, [this.setting.setting_id], this.setting)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Error: Unable to submit form');
                    } else {
                        alert('Success: Setting updated successfully');
                        this.location.back();
                    }
                },
                (error) => alert('Error: Unable to submit form')
            );
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }


}



// WEBPACK FOOTER //
// ./src/app/settings/setting-edit.component.ts